<script>
  import LoadingSpinner from "./LoadingSpinner.svelte";
  export let label;
  export let clickFn;
  export let type = "orange";
  export let width = "auto"; // auto, inherit
  export let padding = "1.2rem 3rem";
  export let loading = false;
  export let loadingSize = 15;
  export let loadingNumberOfRects = 3;
</script>

{#if loading}
  <button class={type + " " + width} style="padding: {padding}" disabled>
    <LoadingSpinner size={loadingSize} numberOfRects={loadingNumberOfRects} />
  </button>
{:else}
  <button
    class={type + " " + width}
    style="padding: {padding}"
    on:click={clickFn}
  >
    {label}
  </button>
{/if}

<style>
  button {
    font-family: "Oswald", sans-serif;
    font-weight: 500;
    border: none;
    font-size: 1.5rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    cursor: pointer;
    border: 2px solid transparent;
    transition: background-color 0.2s ease;
  }

  .orange {
    background-color: #fe5900;
    border: 2px solid #fe5900;
    color: #fff;
  }

  .orange:hover {
    background-color: transparent;
    color: #fe5900;
  }

  .black-o {
    background-color: #fff;
    border: 2px solid #000;
    color: #000;
  }

  .black-o:hover {
    background-color: #000;
    border: 2px solid #000;
    color: #fff;
  }

  .auto {
    width: auto;
  }

  .inherit {
    width: inherit;
  }
</style>
